let pageConfig = {};

// 列表展示项
pageConfig.listColumns = [
    {
        label: '充电站',
        props: 'stationName',
        minWidth: 200,
    },
    {
        label: '桩数量',
        props: 'pileNum',
        minWidth: 200,
        sortable:'custom',
    },
    {
        label: '理论数据（1单/桩）',
        props: 'theoretical',
        minWidth: 200,
        sortable:'custom',
    },
    {
        label: '零元订单数量',
        props: 'zeroOrderCount',
        minWidth: 200,
        sortable:'custom',
    },
    {
        label: '未充电的桩数量',
        props: 'unchargedCount',
        minWidth: 200,
        sortable:'custom',
    },
    
   
    
];

// // 列表展示项
// pageConfig.detailTableColumns = [
//     {
//         label: '合计订单',
//         props: 'mobile',
//         minWidth: 200,
//     },
//     {
//         label: '桩到家订单（元）',
//         props: 'registerDate',
//         minWidth: 200,
//     },
//     {
//         label: '自营订单（元）',
//         props: 'custDto',
//         minWidth: 200,
//     },
//     {
//         label: '充电量（kW·h)',
//         props: 'custDto',
//         minWidth: 200,
//     },
//     {
//         label: '用户量（人）',
//         props: 'custDto',
//         minWidth: 200,
//     },
//     {
//         label: '订单量（单）',
//         props: 'custDto',
//         minWidth: 120,
//     },
//     {
//         label: '服务费（元）',
//         props: 'custDto',
//         minWidth: 200,
//     },
//     {
//         label: '实际收入（元）',
//         props: 'custDto',
//         minWidth: 180,
//     },
// ];


// // 面包屑
pageConfig.listBreadCrumb = [{
    type: 'title',
    name: '首页',
},
{
    type: 'title',
    name: '财务管理',
},
{
    type: 'title',
    name: '站点运营'
},];

// 列表-表格属性
pageConfig.tableConfig = {
    showSelection: false,
    showIndex: true,
    herderStyle:{background:'#FAFAFA',color: '#8F9BB3',fontSize: '14px',fontFamily:'PingFangSC-Medium, PingFang SC'}
};

// 列表-表格属性
pageConfig.detailTableConfig = {
    showSelection: false,
    showIndex: false,
};

// 列表-分页参数
pageConfig.pagination = {
    current: 1,
    total: 0,
    pageSize: 10,
    pageSizes: [2,3,4,5,10, 20, 50, 100],
}
// 列表-编辑操作
pageConfig.tableEditObj = {
    editKey: 'id',
    editRouter: 'dealerDetail',
};

// 路由
pageConfig.listRouter = 'dealerManageList';

pageConfig.reportRouter = 'dealerReportDetail';

// 详情的面包屑
pageConfig.detailBreadCrumb = [{
    type: 'title',
    name: '首页',
},
{
    type: 'router',
    name: '运营商管理',
    router: 'dealerManageList'
},
{
    type: 'title',
    name: '运营商详情',
}];

pageConfig.addRuleArr = ['dealName','dealAbbrName','organizeNo','contactName','contactPhone','bankCard','bankName','bankCode'];

pageConfig.editRuleArr = ['dealName','dealAbbrName','organizeNo','contactName','contactPhone'];

pageConfig.formRules = {
    dealName: [{
        required: true,
        message: '请填写公司名称',
        trigger: 'blur'
    }],
    dealAbbrName: [{
        required: true,
        message: '请填写公司简称',
        trigger: 'blur'
    }],
    organizeNo: [{
        required: true,
        message: '请填写社会统一组织机构代码',
        trigger: 'blur'
    }],
    contactName: [{
        required: true,
        message: '请填写公司联系人1',
        trigger: 'blur'
    }],
    contactPhone: [{
        required: true,
        message: '请填写联系方式',
        trigger: 'blur'
    }],
    bankCard: [{
        required: true,
        message: '请填写收款方银行卡号',
        trigger: 'blur'
    }],
    bankName: [{
        required: true,
        message: '请填写收款方用户名',
        trigger: 'blur'
    }],

    bankCode: [{
        required: true,
        message: '请填开户行编号',
        trigger: 'blur'
    }],
    serviceTel: [{
        required: true,
        message: '请填写客服电话',
        trigger: 'blur'
    }],
    turnoverMerchantCode: [{
        required: true,
        message: '请填写微信商户编号',
        trigger: 'blur'
    }],
    wxMerchantName: [{
        required: true,
        message: '请填写微信商户全称',
        trigger: 'blur'
    }],
};


export default pageConfig;